/**
 * Path to editorial content for industry center
 * @type {string}
 */
export const INDUSTRY_CENTER_GLOBAL_NAV_PATH = 'editorial/includes/industry/global-nav';
